import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogContainerComponent } from 'src/common-panel/components/dialog-container/dialog-container.component';
import { DeletePatientDialogComponent } from '../dialogs/delete-patient-dialog/delete-patient-dialog.component';
import { ResetPasswordDialogComponent } from '../dialogs/reset-password-dialog/reset-password-dialog.component';
import { TransferPatientDialogComponent } from '../dialogs/transfer-patient-dialog/transfer-patient-dialog.component';
import { ReviewTransferPatientDialogComponent } from '../dialogs/review-transfer-patient-dialog/review-transfer-patient-dialog.component';
import { GenerateCodesCSVDialogComponent } from '../dialogs/generate-codes-csv-dialog/generate-codes-csv-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class PMDialogsManagerService
{

  constructor(public dialog: MatDialog) { }

  showResetPasswordDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "60em",
        data: ResetPasswordDialogComponent
      });
  }

  showDeletePatientDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "60em",
        data: DeletePatientDialogComponent
      });
  }

  showTransferPatientDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "60em",
        data: TransferPatientDialogComponent
      });
  }


  showReviewTransferPatientDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "60em",
        data: ReviewTransferPatientDialogComponent
      });
  }

  showGenerateCodesCSVDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "60em",
        data: GenerateCodesCSVDialogComponent
      });
  }
}
